export default __webpack_public_path__ + "static/media/bgpom.16cc9064.jpg";